import {
  ShoppingCart as OrderIcon,
  Inventory as InventoryItemIcon,
  LocalShipping as VendorIcon,
  Build as ToolingIcon,
  Storefront as ExteriorSignageIcon,
  RequestQuote as ExteriorSignageQuoteIcon,
  Loyalty as MerchandisingProgramIcon,
  ViewModule as PanelTypeIcon,
  Assignment as CertificationToolIcon,
  Campaign as BannerIcon,
} from '@mui/icons-material';

export const BlobStorageTypeEnumValue = {
  Order: 1,
  InventoryItem: 2,
  Vendor: 3,
  Tooling: 4,
  ExteriorSignage: 5,
  ExteriorSignageQuote: 6,
  MerchandisingProgram: 7,
  PanelType: 8,
  CertificationTool: 9,
  SupportChat: 10,
  SupportChatReply: 11,
  Banner: 12,
  DealerPortalMenu: 13,
};

export const BlobStorageTypeEnum = [
  {
    value: BlobStorageTypeEnumValue.Order,
    name: 'Order',
    labelFrench: 'Commande',
    labelEnglish: 'Order',
    icon: OrderIcon,
  },
  {
    value: BlobStorageTypeEnumValue.InventoryItem,
    name: 'InventoryItem',
    labelFrench: "Article d'inventaire",
    labelEnglish: 'Inventory Item',
    icon: InventoryItemIcon,
  },
  {
    value: BlobStorageTypeEnumValue.Vendor,
    name: 'Vendor',
    labelFrench: 'Fournisseur',
    labelEnglish: 'Vendor',
    icon: VendorIcon,
  },
  {
    value: BlobStorageTypeEnumValue.Tooling,
    name: 'Tooling',
    labelFrench: 'Outillage',
    labelEnglish: 'Tooling',
    icon: ToolingIcon,
  },
  {
    value: BlobStorageTypeEnumValue.ExteriorSignage,
    name: 'ExteriorSignage',
    labelFrench: 'Signalisation extérieure',
    labelEnglish: 'Exterior Signage',
    icon: ExteriorSignageIcon,
  },
  {
    value: BlobStorageTypeEnumValue.ExteriorSignageQuote,
    name: 'ExteriorSignageQuote',
    labelFrench: 'Soumission signalisation extérieure',
    labelEnglish: 'Exterior Signage Quote',
    icon: ExteriorSignageQuoteIcon,
  },
  {
    value: BlobStorageTypeEnumValue.MerchandisingProgram,
    name: 'MerchandisingProgram',
    labelFrench: 'Programme de marchandisage',
    labelEnglish: 'Merchandising Program',
    icon: MerchandisingProgramIcon,
  },
  {
    value: BlobStorageTypeEnumValue.PanelType,
    name: 'PanelType',
    labelFrench: 'Type de panneau',
    labelEnglish: 'Panel Type',
    icon: PanelTypeIcon,
  },
  {
    value: BlobStorageTypeEnumValue.CertificationTool,
    name: 'CertificationTool',
    labelFrench: 'Outil de certification',
    labelEnglish: 'Certification Tool',
    icon: CertificationToolIcon,
  },
  {
    value: BlobStorageTypeEnumValue.Banner,
    name: 'Banner',
    labelFrench: 'Bannière',
    labelEnglish: 'Banner',
    icon: BannerIcon,
  },
];

export const BlobStorageEnvironmentEnumValue = {
  Dev: 0,
  Test: 1,
  Prod: 2,
};

export const BlobStorageEnvironmentEnum = [
  {
    value: BlobStorageEnvironmentEnumValue.Dev,
    name: 'Dev',
    labelFrench: 'Développement',
    labelEnglish: 'Development',
  },
  {
    value: BlobStorageEnvironmentEnumValue.Test,
    name: 'Test',
    labelFrench: 'Test',
    labelEnglish: 'Test',
  },
  {
    value: BlobStorageEnvironmentEnumValue.Prod,
    name: 'Prod',
    labelFrench: 'Production',
    labelEnglish: 'Production',
  },
];

/**
 * Get blob storage type configuration by type value
 * @param {number} typeValue - The type value from BlobStorageTypeEnumValue
 * @returns {Object|null} The type configuration object or null if not found
 */
export const getStorageTypeConfig = typeValue => {
  return BlobStorageTypeEnum.find(type => type.value === typeValue) || null;
};

/**
 * Get localized storage type label
 * @param {number} typeValue - The type value from BlobStorageTypeEnumValue
 * @param {string} language - The current language ('en' or 'fr')
 * @returns {string} The localized label
 */
export const getStorageTypeLabel = (typeValue, language = 'en') => {
  const config = getStorageTypeConfig(typeValue);
  if (!config) return 'Unknown';
  return language === 'fr' ? config.labelFrench : config.labelEnglish;
};

/**
 * Get blob storage environment configuration by environment value
 * @param {number} envValue - The environment value from BlobStorageEnvironmentEnumValue
 * @returns {Object|null} The environment configuration object or null if not found
 */
export const getStorageEnvironmentConfig = envValue => {
  return BlobStorageEnvironmentEnum.find(env => env.value === envValue) || null;
};

/**
 * Get localized storage environment label
 * @param {number} envValue - The environment value from BlobStorageEnvironmentEnumValue
 * @param {string} language - The current language ('en' or 'fr')
 * @returns {string} The localized label
 */
export const getStorageEnvironmentLabel = (envValue, language = 'en') => {
  const config = getStorageEnvironmentConfig(envValue);
  if (!config) return 'Unknown';
  return language === 'fr' ? config.labelFrench : config.labelEnglish;
};

export default BlobStorageTypeEnum;
